import { createApi } from '@reduxjs/toolkit/query/react';
import loansApiBaseQuery from '@app/api/baseQuery/loansApiBaseQuery';
import { TAG_TYPES } from './tagTypes';
export const baseApi = createApi({
    reducerPath: 'api',
    baseQuery: loansApiBaseQuery,
    tagTypes: Object.values(TAG_TYPES),
    endpoints: () => ({}),
});
